/* tslint:disable:max-file-line-count */

export const lastNames: string[] = [
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Jones',
  'Miller',
  'Davis',
  'Garcia',
  'Rodriguez',
  'Wilson',
  'Martinez',
  'Anderson',
  'Taylor',
  'Thomas',
  'Hernandez',
  'Moore',
  'Martin',
  'Jackson',
  'Thompson',
  'White',
  'Lopez',
  'Lee',
  'Gonzalez',
  'Harris',
  'Clark',
  'Lewis',
  'Robinson',
  'Walker',
  'Perez',
  'Hall',
  'Young',
  'Allen',
  'Sanchez',
  'Wright',
  'King',
  'Scott',
  'Green',
  'Baker',
  'Adams',
  'Nelson',
  'Hill',
  'Ramirez',
  'Campbell',
  'Mitchell',
  'Roberts',
  'Carter',
  'Phillips',
  'Evans',
  'Turner',
  'Torres',
  'Parker',
  'Collins',
  'Edwards',
  'Stewart',
  'Flores',
  'Morris',
  'Nguyen',
  'Murphy',
  'Rivera',
  'Cook',
  'Rogers',
  'Morgan',
  'Peterson',
  'Cooper',
  'Reed',
  'Bailey',
  'Bell',
  'Gomez',
  'Kelly',
  'Howard',
  'Ward',
  'Cox',
  'Diaz',
  'Richardson',
  'Wood',
  'Watson',
  'Brooks',
  'Bennett',
  'Gray',
  'James',
  'Reyes',
  'Cruz',
  'Hughes',
  'Price',
  'Myers',
  'Long',
  'Foster',
  'Sanders',
  'Ross',
  'Morales',
  'Powell',
  'Sullivan',
  'Russell',
  'Ortiz',
  'Jenkins',
  'Gutierrez',
  'Perry',
  'Butler',
  'Barnes',
  'Fisher',
  'Henderson',
  'Coleman',
  'Simmons',
  'Patterson',
  'Jordan',
  'Reynolds',
  'Hamilton',
  'Graham',
  'Kim',
  'Gonzales',
  'Alexander',
  'Ramos',
  'Wallace',
  'Griffin',
  'West',
  'Cole',
  'Hayes',
  'Chavez',
  'Gibson',
  'Bryant',
  'Ellis',
  'Stevens',
  'Murray',
  'Ford',
  'Marshall',
  'Owens',
  'Mcdonald',
  'Harrison',
  'Ruiz',
  'Kennedy',
  'Wells',
  'Alvarez',
  'Woods',
  'Mendoza',
  'Castillo',
  'Olson',
  'Webb',
  'Washington',
  'Tucker',
  'Freeman',
  'Burns',
  'Henry',
  'Vasquez',
  'Snyder',
  'Simpson',
  'Crawford',
  'Jimenez',
  'Porter',
  'Mason',
  'Shaw',
  'Gordon',
  'Wagner',
  'Hunter',
  'Romero',
  'Hicks',
  'Dixon',
  'Hunt',
  'Palmer',
  'Robertson',
  'Black',
  'Holmes',
  'Stone',
  'Meyer',
  'Boyd',
  'Mills',
  'Warren',
  'Fox',
  'Rose',
  'Rice',
  'Moreno',
  'Schmidt',
  'Patel',
  'Ferguson',
  'Nichols',
  'Herrera',
  'Medina',
  'Ryan',
  'Fernandez',
  'Weaver',
  'Daniels',
  'Stephens',
  'Gardner',
  'Payne',
  'Kelley',
  'Dunn',
  'Pierce',
  'Arnold',
  'Tran',
  'Spencer',
  'Peters',
  'Hawkins',
  'Grant',
  'Hansen',
  'Castro',
  'Hoffman',
  'Hart',
  'Elliott',
  'Cunningham',
  'Knight',
  'Bradley',
  'Carroll',
  'Hudson',
  'Duncan',
  'Armstrong',
  'Berry',
  'Andrews',
  'Johnston',
  'Ray',
  'Lane',
  'Riley',
  'Carpenter',
  'Perkins',
  'Aguilar',
  'Silva',
  'Richards',
  'Willis',
  'Matthews',
  'Chapman',
  'Lawrence',
  'Garza',
  'Vargas',
  'Watkins',
  'Wheeler',
  'Larson',
  'Carlson',
  'Harper',
  'George',
  'Greene',
  'Burke',
  'Guzman',
  'Morrison',
  'Munoz',
  'Jacobs',
  'Obrien',
  'Lawson',
  'Franklin',
  'Lynch',
  'Bishop',
  'Carr',
  'Salazar',
  'Austin',
  'Mendez',
  'Gilbert',
  'Jensen',
  'Williamson',
  'Montgomery',
  'Harvey',
  'Oliver',
  'Howell',
  'Dean',
  'Hanson',
  'Weber',
  'Garrett',
  'Sims',
  'Burton',
  'Fuller',
  'Soto',
  'Mccoy',
  'Welch',
  'Chen',
  'Schultz',
  'Walters',
  'Reid',
  'Fields',
  'Walsh',
  'Little',
  'Fowler',
  'Bowman',
  'Davidson',
  'May',
  'Day',
  'Schneider',
  'Newman',
  'Brewer',
  'Lucas',
  'Holland',
  'Wong',
  'Banks',
  'Santos',
  'Curtis',
  'Pearson',
  'Delgado',
  'Valdez',
  'Pena',
  'Rios',
  'Douglas',
  'Sandoval',
  'Barrett',
  'Hopkins',
  'Keller',
  'Guerrero',
  'Stanley',
  'Bates',
  'Alvarado',
  'Beck',
  'Ortega',
  'Wade',
  'Estrada',
  'Contreras',
  'Barnett'
];



// WEBPACK FOOTER //
// src/helpers/last-names.ts